import {
  BUNDLES_DATA,
  PATTERNS_DATA,
  PRODUCT_TYPES_DATA,
  SIZES_DATA,
  UPSELLS_DATA,
  regexSkuMatching
} from '../bab/bab.utils'

export function getSubscriptionId (subscriptionData, productsData) {
  if (productsData === null) {
    return 0
  }

  const subscriptionBundle = subscriptionData.bundle

  let baseSku = BUNDLES_DATA.find(
    (bundle) => bundle.id === subscriptionBundle
  ).skuPart

  let upgradeSkuPart = ''

  const subscriptionUpgrades = subscriptionData.upgrades

  const linimentUpsellData = UPSELLS_DATA.find(
    (upsell) => upsell.id === 'liniment'
  )
  const washUpsellData = UPSELLS_DATA.find((upsell) => upsell.id === 'wash')
  const cottonsUpsellData = UPSELLS_DATA.find(
    (upsell) => upsell.id === 'cottons'
  )
  const wipesUpsellData = UPSELLS_DATA.find((upsell) => upsell.id === 'wipes')

  const hasLinimentUpgrade = subscriptionUpgrades.includes(
    linimentUpsellData.variants[0].upgradeData.sku
  )
  const hasWashUpgrade = subscriptionUpgrades.includes(
    washUpsellData.variants[0].upgradeData.sku
  )
  const hasCottonsUpgrade = subscriptionUpgrades.includes(
    cottonsUpsellData.variants[0].upgradeData.sku
  )

  const wipesUpgradesSkus = wipesUpsellData.variants.map(variant => {
    return variant.upgradeData.sku
  })

  const hasWipesUpgrade = wipesUpgradesSkus.some(wipesUpgradesSku => {
    return subscriptionUpgrades.includes(wipesUpgradesSku)
  })

  if (hasCottonsUpgrade) upgradeSkuPart += 'P'
  if (hasWipesUpgrade) upgradeSkuPart += 'W'
  if (hasLinimentUpgrade) upgradeSkuPart += 'S'
  if (hasWashUpgrade) upgradeSkuPart += 'S'

  const subscriptionSku = baseSku.replace('{upgradeData}', upgradeSkuPart)
  const subscriptionProduct = productsData.find((product) => {
    return product.sku === subscriptionSku
  })

  return subscriptionProduct.shopify_variant_id
}

export async function addBoxToCart (subscriptionData, productsData, t) {
  const boxVariantId = getSubscriptionId(subscriptionData, productsData)

  // On construit la box
  const box = {}

  box['bundle_id'] = boxVariantId
  box['type'] = subscriptionData.bundle
  box['frequency'] = subscriptionData.frequency
  box['variants'] = subscriptionData.variants
  box['upsells'] = subscriptionData.upsells
  // box['step'] = 'pants';

  const linimentUpsellData = UPSELLS_DATA.find(
    (upsell) => upsell.id === 'liniment'
  )
  const washUpsellData = UPSELLS_DATA.find((upsell) => upsell.id === 'wash')
  const cottonsUpsellData = UPSELLS_DATA.find(
    (upsell) => upsell.id === 'cottons'
  )
  const wipesUpsellData = UPSELLS_DATA.find((upsell) => upsell.id === 'wipes')

  if (
    subscriptionData.upgrades.includes(
      linimentUpsellData.variants[0].upgradeData.sku
    )
  ) {
    box['liniment'] = linimentUpsellData.variants[0].upgradeData.sku
  }

  if (
    subscriptionData.upgrades.includes(
      washUpsellData.variants[0].upgradeData.sku
    )
  ) {
    box['wash'] = washUpsellData.variants[0].upgradeData.sku
  }

  if (
    subscriptionData.upgrades.includes(
      cottonsUpsellData.variants[0].upgradeData.sku
    )
  ) {
    box['cottons'] = cottonsUpsellData.variants[0].upgradeData.sku
  }

  const wipesUpgradesSkus = wipesUpsellData.variants.map(variant => {
    return variant.upgradeData.sku
  })
  const wipesUpgradeSku = subscriptionData.upgrades.find(upgradeSKU => {
    return wipesUpgradesSkus.includes(upgradeSKU)
  })
  if (wipesUpgradeSku) box['wipes'] = wipesUpgradeSku

  // On construit le panier
  const cart = {}

  cart['id'] = boxVariantId
  cart['quantity'] = 1

  const cartProperties = {}

  cart['properties'] = cartProperties

  cartProperties['_bundle_box'] = box
  cartProperties['_interval_count'] = subscriptionData.frequency
  cartProperties['_interval'] = 'day'

  const variantsArray = Object.entries(subscriptionData.variants)

  let variantsData = []

  variantsArray.map(([sizeId, patternArray], index) => {
    const productTypeData = PRODUCT_TYPES_DATA.find((producType) =>
      producType.sizes.includes(sizeId)
    )

    const sizeData = SIZES_DATA.find((size) => size.id === sizeId)
    const sizeShorthand = t(sizeData.translationKeys.shortHand)

    const reducedVariantData = patternArray.reduce((acc, patternId) => {
      const patternData = PATTERNS_DATA.find(
        (pattern) => pattern.id === patternId
      )
      const patternName = t(patternData.translationKeys.name)

      const skuBase = productTypeData.skuPart
      const sizeSkuPart = sizeData.skuPart
      const patternSkuPart = patternData.skuPart
      const regexSku = regexSkuMatching(skuBase, patternSkuPart, sizeSkuPart)

      const productData = productsData.find(
        (product) => regexSku.test(product.sku)
      )

      if (!productData) {
        console.error(`Error processing pattern "${regexSku} :`)
        return acc
      }

      const patternFinalName = `${patternName} ${sizeShorthand}`
      const patternVariantId = productData.shopify_variant_id

      const existingItem = acc.find((item) => item.id === patternVariantId)

      if (existingItem) {
        existingItem.quantity += 1
      } else {
        acc.push({ id: patternVariantId, name: patternFinalName, quantity: 1 })
      }

      return acc
    }, [])

    variantsData = variantsData.concat(reducedVariantData)
  })

  let bundlePartCounter = 0

  variantsData.map(({ id, name, quantity }) => {
    if (cartProperties[name] !== undefined) {
      cartProperties[name] += quantity
    } else {
      cartProperties[name] = quantity
    }
    for (let i = 0; i < quantity; i++) {
      const bundlePartKey = `_bundle_part_${bundlePartCounter}`
      cartProperties[bundlePartKey] = id
      bundlePartCounter++
    }
  })

  const upsellsData = subscriptionData.upgrades.reduce((acc, upsellSku) => {
    const upsellData = UPSELLS_DATA.find((upsell) =>
      upsell.variants.find((variant) => variant.upgradeData.sku === upsellSku)
    )

    const hasMoreThanOneVariant = upsellData.variants.length > 1

    const variantIndex = upsellData.variants.findIndex(
      (variantData) => variantData.upgradeData.sku === upsellSku
    )

    const productData = productsData.find(
      (product) => product.sku === upsellSku
    )

    if (!productData) {
      console.error(`Error processing upsell "${upsellSku} :`)
      return acc
    }

    const upsellVariantId = productData.shopify_variant_id

    const upsellName = hasMoreThanOneVariant
      ? `${t(upsellData.translationKeys.name)} ${t(
        upsellData.variants[variantIndex].translationKeys.optionName
      )}`
      : t(upsellData.translationKeys.name)

    const upsellQuantity =
      upsellData.variants[variantIndex].upgradeData.quantity

    acc.push({
      id: upsellVariantId,
      name: upsellName,
      quantity: upsellQuantity
    })

    return acc
  }, [])

  upsellsData.map(({ id, name, quantity }) => {
    cartProperties[name] = quantity
    for (let i = 0; i < quantity; i++) {
      const bundlePartKey = `_bundle_part_${bundlePartCounter}`
      cartProperties[bundlePartKey] = id
      bundlePartCounter++
    }
  })

  // On ajoute l'abonnement au panier
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    credentials: 'same-origin',
    responseType: 'json',
    body: JSON.stringify(cart)
  })
}

export async function addUpsellsToCart (subscriptionData, productsData, t) {
  // Je crée ma payload
  const upsellsPayload = {
    items: []
  }

  subscriptionData.upsells.map((upsellSku) => {
    const upsellData = UPSELLS_DATA.find((upsell) =>
      upsell.variants.find((variant) => variant.upsellData.sku === upsellSku)
    )

    const variantIndex = upsellData.variants.findIndex(
      (variantData) => variantData.upsellData.sku === upsellSku
    )

    const productData = productsData.find(
      (product) => product.sku === upsellSku
    )

    if (!productData) {
      return console.error(`Error processing upsell "${upsellSku} :`)
    }

    const upsellVariantId = productData.shopify_variant_id

    const upsellQuantity =
      upsellData.variants[variantIndex].upsellData.quantity

    upsellsPayload.items.push({
      id: upsellVariantId,
      quantity: upsellQuantity
    })
  })

  // On ajoute les upsells au panier
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    credentials: 'same-origin',
    responseType: 'json',
    body: JSON.stringify(upsellsPayload)
  })
}
